import React, { useCallback, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import Modal from 'react-bootstrap/Modal';

import Select from '../../../../Select';

import './style.css';

import iconTag from '../../../../../assets/images/icon_tag.svg';

const ModalAddTag = ({ botId, isActive, onClose, onSubmit }) => {
  const [values, setValues] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleChange = useCallback((_values) => {
    if (_values) {
      setValues(_values);
    } else {
      setValues([]);
    }
  }, []);

  const handleInputChange = useCallback((_value) => {
    if(_value.includes(';')){
      setInputValue(_value.replace(';', ''));
      toastr.error(
        'Erro',
        `Tags não podem conter ;`
      );
    }else{
      setInputValue(_value);
    }
  });

  const handleKeyDown = useCallback(
    (event) => {
      if (!inputValue) return;
      // eslint-disable-next-line default-case
      switch (event.key) {
        case 'Enter':
        case 'Tab':
          setInputValue('');

          const tagExists = values.find((tag) => tag.value === inputValue);
          if (tagExists){
            toastr.error(
              'Erro',
              `Já existe uma tag com esse nome`
            );
            return;
          }
          setValues([...values, { label: inputValue, value: inputValue }]);

          event.preventDefault();
      }
    },
    [inputValue, setInputValue, values]
  );

  const handleSubmit = useCallback(() => {
    if (inputValue !== '') {
      const tagExists = values.find((tag) => tag.value === inputValue);
      if (tagExists) return;
      values.push({ label: inputValue, value: inputValue });
      setInputValue('');
    }

    if (!values.length) return;

    const formattedValuesToSubmit = values.map((tag) => ({
      botId,
      name: tag.value,
      active: true,
      type: 'user',
    }));

    onSubmit(formattedValuesToSubmit);
  }, [inputValue, values, onSubmit, setInputValue, botId]);

  return (
    <Modal
      show={isActive}
      onHide={onClose}
      className="modal-tag modal-content-tag"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <img src={iconTag} alt="Tag" /> Nova Tag
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div>
          <Select
            label="Insira sua tag ou crie várias tags apertando em “enter”"
            inputValue={inputValue}
            value={values}
            onChange={handleChange}
            onInputChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onSelectResetsInput={false}
            isMulti
            menuIsOpen={false}
            inputMaxLength={50}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={handleSubmit}>
          salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddTag;